// extracted by mini-css-extract-plugin
export default {"star-rating-container":"StarRating_star-rating-container__Xy1Pu","star":"StarRating_star__BtbjR"};